// extracted by css-extract-rspack-plugin
export default {"databaseDataSelectors":"MetadataHeader-module__databaseDataSelectors___UrllU"};